import ProductImg1 from '../adminAssets/images/templates/products/product_1.png';
import ProductImg2 from '../adminAssets/images/templates/products/product_2.png';
import ProductImg3 from '../adminAssets/images/templates/products/product_3.png';
import ProductImg4 from '../adminAssets/images/templates/products/product_4.png';
import ProductImg5 from '../adminAssets/images/templates/products/product_5.png';
import ProductImg6 from '../adminAssets/images/templates/products/product_6.png';

import CompanyLogo from '../adminAssets/images/templates/company_logo.png';

export const theme = [
    {
        name: 'default',
        colors: {
            primary: '#000000',
            accountTitle: '#ffffff',
            bubble: '#0046E1',
            breadcrumbBg: '#F4F4F4',
            navActive: '#2563EB',
            sortByBg: '#F4F4F4',
            categoryActive: '#0046E1',
            footerBg: '#000000',
            footerColor: '#ffffff'
        }
    },
    {
        name: 'white',
        colors: {
            primary: '#ffffff',
            accountTitle: '#000000',
            bubble: '#000000',
            breadcrumbBg: '#ffffff',
            navActive: '#000000',
            sortByBg: '#FFFFFF',
            categoryActive: '#000000',
            footerBg: '#ECECEC',
            footerColor: '#000000'
        }
    },
    {
        name: 'orange',
        colors: {
            primary: '#F08400',
            accountTitle: '#ffffff',
            bubble: '#F08400',
            breadcrumbBg: '#FFF3E4',
            navActive: '#F08400',
            sortByBg: '#FFF3E4',
            categoryActive: '#FF9F29',
            footerBg: '#F08400',
            footerColor: '#ffffff'
        }
    },
    {
        name: 'blue',
        colors: {
            primary: '#0067DC',
            accountTitle: '#ffffff',
            bubble: '#0067DC',
            breadcrumbBg: '#EBF4FF',
            navActive: '#0067DC',
            sortByBg: '#EBF4FF',
            categoryActive: '#0067DC',
            footerBg: '#0067DC',
            footerColor: '#ffffff'
        }
    },
    {
        name: 'red',
        colors: {
            primary: '#990A02',
            accountTitle: '#ffffff',
            bubble: '#990A02',
            breadcrumbBg: '#FFEEEE',
            navActive: '#990A02',
            sortByBg: '#FEDEDC',
            categoryActive: '#990A02',
            footerBg: '#990A02',
            footerColor: '#ffffff'
        }
    },
    {
        name: 'green',
        colors: {
            primary: '#02992F',
            accountTitle: '#ffffff',
            bubble: '#02992F',
            breadcrumbBg: '#E7FFEE',
            navActive: '#02992F',
            sortByBg: '#E7FFEE',
            categoryActive: '#02992F',
            footerBg: '#02992F',
            footerColor: '#ffffff'
        }
    }
];

export const dummyStoreInfo = {
    businessName: 'Shop Name',
    description: "Shop's description\nWelcome to our store! We offer high quality products with the best prices. Happy shopping!",
    logo: CompanyLogo,
    topBanner: 'https://via.placeholder.com/1440x300',
    viewCount: 1234,
    link: 'www.shopname.com'
};

export const dummyCategories = [
    { id: 'cat1', name: "Women's Wear" },
    { id: 'cat2', name: "Men's Wear" },
    { id: 'cat3', name: 'Bag' },
    { id: 'cat4', name: 'Accessories' }
];

export const dummyProducts = [
    {
        id: 'prod1',
        slug: 'fashionable-bag',
        name: 'Fashionable Bag Local Brand',
        price: 28.99,
        discountPrice: 14.99,
        discount: 48,
        rating: 4.8,
        reviews: '17k',
        photoData: [{ url: ProductImg1 }]
    },
    {
        id: 'prod2',
        slug: 'denim-jacket',
        name: 'Denim Jacket High Quality',
        price: 28.99,
        discountPrice: 14.99,
        discount: 48,
        rating: 4.8,
        reviews: '17k',
        photoData: [{ url: ProductImg2 }]
    },
    {
        id: 'prod3',
        slug: 'womens-shoes',
        name: "Women's Shoes Beige Colour",
        price: 28.99,
        discountPrice: 14.99,
        discount: 48,
        rating: 4.8,
        reviews: '17k',
        photoData: [{ url: ProductImg3 }]
    },
    {
        id: 'prod4',
        slug: 'mens-boots',
        name: "Men's Boots Black Colour",
        price: 28.99,
        discountPrice: 14.99,
        discount: 48,
        rating: 4.8,
        reviews: '17k',
        photoData: [{ url: ProductImg4 }]
    },
    {
        id: 'prod5',
        slug: 'mens-sweater',
        name: "Men's Sweater Local Brand Quality",
        price: 28.99,
        discountPrice: 14.99,
        discount: 48,
        rating: 4.8,
        reviews: '17k',
        photoData: [{ url: ProductImg5 }]
    },
    {
        id: 'prod6',
        slug: 'blue-stripes-shirt',
        name: "Blue Stripes Men's Shirt",
        price: 28.99,
        discountPrice: 14.99,
        discount: 48,
        rating: 4.8,
        reviews: '17k',
        photoData: [{ url: ProductImg6 }]
    }
];
